var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDigitalP4PolygonLeftUp(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 246,
    viewBox: "0 0 64 246",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M-106.31 161.863L-9.17139 0.0444761L63.0367 245.185L-106.31 161.863Z",
    fill: "#7A001F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDigitalP4PolygonLeftUp);
export default __webpack_public_path__ + "static/media/Digital_P4_Polygon_LeftUp.b49fa09283d36dbfe71263fba1e2caf2.svg";
export { ForwardRef as ReactComponent };